import {
  HOOK_SIDEBAR_OPEN_HISTORY,
  HOOK_SIDEBAR_OPEN_COLLECTIONS,
  HOOK_PLAYER_SEEK_TO,
  HOOK_EDITOR_SYNTHESIZE,
  HOOK_HIGHLIGHT_SPEAKER_SELECTOR,
} from "@/shared/hooks"

export function useHook() {
  const nuxtApp = useNuxtApp()

  const callSidebarOpenHistory = () => {
    nuxtApp.callHook(HOOK_SIDEBAR_OPEN_HISTORY)
  }

  const onSidebarOpenHistory = (callback: () => void) => {
    nuxtApp.hook(HOOK_SIDEBAR_OPEN_HISTORY, callback)
  }

  const callSidebarOpenCollections = () => {
    nuxtApp.callHook(HOOK_SIDEBAR_OPEN_COLLECTIONS)
  }

  const onSidebarOpenCollections = (callback: () => void) => {
    nuxtApp.hook(HOOK_SIDEBAR_OPEN_COLLECTIONS, callback)
  }

  const callPlayerSeekTo = (value: { detail: number }) => {
    nuxtApp.callHook(HOOK_PLAYER_SEEK_TO, value)
  }

  const onPlayerSeekTo = (callback: (value: { detail: number }) => void) => {
    nuxtApp.hook(HOOK_PLAYER_SEEK_TO, callback)
  }

  const callEditorSynthesize = () => {
    nuxtApp.callHook(HOOK_EDITOR_SYNTHESIZE)
  }

  const onEditorSynthesize = (callback: () => void) => {
    nuxtApp.hook(HOOK_EDITOR_SYNTHESIZE, callback)
  }

  const callHighlightSpeakerSelector = () => {
    nuxtApp.callHook(HOOK_HIGHLIGHT_SPEAKER_SELECTOR)
  }

  const onHighlightSpeakerSelector = (callback: () => void) => {
    nuxtApp.hook(HOOK_HIGHLIGHT_SPEAKER_SELECTOR, callback)
  }

  return {
    callSidebarOpenHistory,
    onSidebarOpenHistory,

    callSidebarOpenCollections,
    onSidebarOpenCollections,

    callPlayerSeekTo,
    onPlayerSeekTo,

    callEditorSynthesize,
    onEditorSynthesize,

    callHighlightSpeakerSelector,
    onHighlightSpeakerSelector,
  }
}
